import { createSliceSelectors } from '../utils'

const ModalSelectors = createSliceSelectors('modal', [
    /*=============================================
     =        Direct Data Model Mappings          =
     =============================================*/

    'modalShown',
    'modalStack',

    /*=============================================
     =           Aggregated Selectors             =
     =============================================*/

    /**
     * returns a list of current registration modals open
     * on screen in the form of [{ [modalName]: modalData }, ...]
     *
     **/
    'registrationModalsOpen',
    /**
     * get the trigger source of the current registration modal
     * if available
     *
     **/
    'activeRegistrationModalSource',
])

export default ModalSelectors
